// @ts-nocheck
import linksReducer, { LinksActions } from "@store/Framework/Store/Store/Links/LinksReducer";
import pagesReducer, { PagesActions } from "@store/Framework/Store/Store/Pages/PagesReducer";
import { combineReducers } from "redux";

const storeReducer = combineReducers({
    pages: pagesReducer,
    links: linksReducer,
});

export type StoreActions = PagesActions | LinksActions;

export default storeReducer;
